var migLoaderLoaded = false;
var isOverrideFragmentEnabled = false;
var MigIframe = (function () {
    function MigIframe(id, iframe) {
        var _this = this;
        this.id = id;
        this.iframe = iframe;
        this.iframe.setAttribute('id', 'iframe_' + this.id);
        this.firstInit = true;
        this.firstload = true;
        this.loaded = false;
        ["resize", "scroll"].forEach(function (eventName) {
            window.addEventListener(eventName, function () {
                _this.sendViewportSize(eventName);
            });
        });
        if (this.iframe.getAttribute('data-src')) {
            this.datasrc = this.iframe.getAttribute('data-src');
            var src = this.datasrc;
            var get = this.getURLParams();
            if ('migUrl' in get) {
                var migUrl = get.migUrl;
                if (src.indexOf("/", 8) != -1) {
                    var slashPos = src.indexOf("/", 8);
                    src = src.substring(0, slashPos);
                }
                if (src.indexOf("?") != -1) {
                    var getPos = src.indexOf("?");
                    src = src.substring(0, getPos);
                }
                var hash = "";
                var splittedUrl = migUrl.split("#");
                if (splittedUrl.length > 1) {
                    migUrl = splittedUrl[0];
                    hash = '#' + splittedUrl[1];
                }
                src += migUrl + "?from=integration" + hash;
                history.replaceState(undefined, undefined, location.pathname + '#' + MigIframe.migIdent + migUrl);
            }
            if ('authhash' in get) {
                var authhash = get.authhash;
                src += '?authhash=' + authhash;
            }
            this.iframe.setAttribute('src', src);
        }
        this.iframe.addEventListener('load', function () {
            _this.loaded = true;
            _this.iframe.classList.add("show");
            _this.iframe.parentElement.classList.add("show");
            _this.timeoutSendViewport = null;
            _this.requestContentSize('load');
        });
        this.requestContentSize('init');
    }
    MigIframe.prototype.getURLParams = function () {
        var _a = document.location.href.split("?"), base = _a[0], rest = _a.slice(1);
        var parameters = rest.join("&");
        var url = [];
        url.push(base);
        url.push(parameters);
        var get = new Object;
        if (url.length > 1) {
            var params = url[1].split("&");
            for (var i in params) {
                var param = params[i] + '';
                var tmp = param.split("=");
                var variableName = tmp[0] + '';
                var variableValue = tmp[1] + '';
                get[variableName] = decodeURI(variableValue.replace("+", " "));
            }
        }
        return get;
    };
    MigIframe.prototype.sendViewportSize = function (eventName) {
        var _this = this;
        var message = {
            type: 'viewportSize',
            data: {
                event: eventName,
                width: window.innerWidth,
                height: window.innerHeight,
                iframeTop: this.iframe.getBoundingClientRect().top + window.scrollY,
                scrollTop: window.scrollY
            }
        };
        clearTimeout(this.timeoutSendViewport);
        this.timeoutSendViewport = setTimeout(function (e) {
            _this.iframe.contentWindow.postMessage(message, '*');
        }, 100);
    };
    MigIframe.prototype.requestContentSize = function (eventName) {
        var _this = this;
        [0, 250, 1000, 2500].forEach(function (delay) {
            setTimeout(function () {
                _this.sendViewportSize(eventName);
            }, delay);
        });
    };
    MigIframe.migIdent = 'immomig:';
    return MigIframe;
}());
function loadMigIframes() {
    if (migLoaderLoaded) {
        return;
    }
    migLoaderLoaded = true;
    var migIframes = [];
    var counter = 0;
    function scrollIframe(iframe, offset) {
        if (iframe) {
            var scrollOffset = parseInt(iframe.getAttribute('data-scroll-offset')) || 0;
            window.scrollTo({ top: (iframe.getBoundingClientRect().top + window.scrollY) + offset + scrollOffset, behavior: 'smooth' });
        }
        else {
            window.scrollTo({ top: offset, behavior: 'smooth' });
        }
    }
    function getFormatedFragment(obj) {
        var arr = Object.keys(obj).map(function (el) {
            return obj[el];
        });
        arr.sort(function (a, b) {
            if (a > b) {
                return 1;
            }
            else {
                return 0;
            }
        });
        return arr.join('!!');
    }
    function getDataFromFrag(fragment) {
        var data = fragment.split(MigIframe.migIdent);
        data[0] = data[0].substring(0, data[0].length - 1);
        if (data[0] == "") {
            data[0] = "0";
        }
        return data;
    }
    function updateIframe(migIframe, firstload) {
        if (isOverrideFragmentEnabled) {
            migIframe.firstload = false;
            var updated_1 = false;
            var currentFragment = window.location.hash;
            currentFragment = currentFragment.substring(1, currentFragment.length);
            if (currentFragment.indexOf(MigIframe.migIdent) !== -1) {
                var splittedFragment = currentFragment.split('!!');
                splittedFragment.forEach(function (frag) {
                    var data = getDataFromFrag(frag);
                    if (parseInt(data[0]) == migIframe.id) {
                        var src = migIframe.iframe.getAttribute("data-hostname") + data[1];
                        migIframe.iframe.setAttribute('src', src);
                        updated_1 = true;
                    }
                });
            }
            if (!firstload && !updated_1) {
                if (migIframe.iframe.getAttribute("src") != migIframe.iframe.getAttribute("data-src")) {
                    migIframe.iframe.setAttribute("src", migIframe.iframe.getAttribute("data-src"));
                }
            }
        }
    }
    function overrideFragment(id, fragment) {
        if (isOverrideFragmentEnabled) {
            var newFragment = '#';
            var currentFragment = window.location.hash;
            currentFragment = currentFragment.substring(1, currentFragment.length);
            if (id == 0) {
                fragment = MigIframe.migIdent + fragment;
            }
            else {
                fragment = id + '-' + MigIframe.migIdent + fragment;
            }
            var updated_2 = false;
            var oldFragments = currentFragment.split('!!');
            var fragments_1 = [];
            oldFragments.forEach(function (frag) {
                var data = getDataFromFrag(frag);
                if (parseInt(data[0]) == id) {
                    fragments_1[id] = fragment;
                    updated_2 = true;
                }
                else {
                    if (frag != '') {
                        fragments_1[data[0]] = frag;
                    }
                }
            });
            if (!updated_2) {
                fragments_1[id] = fragment;
            }
            newFragment += getFormatedFragment(fragments_1);
            history.replaceState(undefined, undefined, newFragment);
        }
    }
    function hashUpdated() {
        migIframes.forEach(function (migIframe) {
            updateIframe(migIframe, false);
        });
    }
    function listenMessage(msg) {
        var targeted_migIframe = null;
        migIframes.forEach(function (migIframe) {
            if (migIframe.iframe.contentWindow === msg.source) {
                targeted_migIframe = migIframe;
            }
        });
        if (!targeted_migIframe) {
            return;
        }
        if (typeof msg.data == 'object' && 'type' in msg.data) {
            var data = msg.data.data;
            var type = msg.data.type;
            if (type == 'initScrollTop') {
                if (!targeted_migIframe.firstInit) {
                    scrollIframe(targeted_migIframe.iframe, ('offset' in data) ? data.offset : 0);
                }
                targeted_migIframe.firstInit = false;
            }
            else if (type == 'scrollTop') {
                scrollIframe(targeted_migIframe.iframe, ('offset' in data) ? data.offset : 0);
            }
            else if (type == 'overrideFragment') {
                isOverrideFragmentEnabled = ('enabled' in data) ? data.enabled : false;
                if (targeted_migIframe.firstload) {
                    updateIframe(targeted_migIframe, true);
                }
                else {
                    overrideFragment(targeted_migIframe.id, ('pathname' in data) ? data.pathname : "");
                }
            }
            else if (type == 'goToPage') {
                if (('enabled' in data) ? data.enabled : false) {
                    if ('url' in data) {
                        window.location.href = data.url;
                    }
                }
            }
            else if (type == 'contentSize') {
                if ('height' in data) {
                    targeted_migIframe.iframe.height = data.height;
                }
            }
        }
    }
    window.addEventListener("hashchange", hashUpdated);
    window.addEventListener("message", listenMessage, false);
    document.querySelectorAll("iframe.Immomig, iframe#Immomig").forEach(function (iframeEl) {
        migIframes.push(new MigIframe(counter, iframeEl));
        counter++;
    });
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadMigIframes);
}
else {
    loadMigIframes();
}
window.addEventListener('load', loadMigIframes);
//# sourceMappingURL=loader.js.map
